import { Routes } from "@angular/router";
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';
import { AuditDetailsComponent } from "./component/audit-details/audit-details.component";
import { AddAuditComponent } from "./component/add-audit/add-audit.component";
import { AuditListComponent } from "./component/audit-list/audit-list.component";
import { AuditTypeListComponent } from "./component/audit-type-list/audit-type-list.component";
import { AddAuditTypeComponent } from "./component/add-audit-type/add-audit-type.component";

export const AUDIT_ROUTES: Routes = [
    {
        path: 'audit',
        component: LayoutComponent,
        canActivate: [MsalGuard],
        children: [
            { path: '', component: AuditListComponent },
            { path: 'add', component: AddAuditComponent },
            { path: 'audittype', component: AuditTypeListComponent },
            { path: 'audittype/add', component: AddAuditTypeComponent },
            { path: ':id', component: AuditDetailsComponent }
        ]
    }
];
